var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13061 10.8071L22.1965 0.907921C22.9938 0.533408 23.9263 0.917115 24.2783 1.76524C24.404 2.06594 24.4426 2.3984 24.3912 2.72343L21.5641 20.5911C21.3904 21.6887 20.413 22.4294 19.3812 22.2446C19.0867 22.1918 18.808 22.0657 18.568 21.8769L11.4436 16.263C10.7425 15.7112 10.595 14.6598 11.1144 13.9142C11.1736 13.8285 11.2415 13.7487 11.3157 13.6765L18.4589 6.70476C18.5237 6.64176 18.5276 6.53589 18.4684 6.46707C18.4172 6.40826 18.3343 6.39569 18.2687 6.43855L7.42905 13.579C7.03507 13.8377 6.55428 13.9007 6.11298 13.7495L1.19212 12.0607C0.859658 11.9466 0.677269 11.5678 0.784755 11.2151C0.839918 11.0337 0.966469 10.8843 1.13061 10.8071Z",
    fill: "#0086D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/tel.6a72f39ad344e914a85864a722e1a80d.svg";
export { ForwardRef as ReactComponent };